<template>
  <div>
    <div class="columns is-gapless is-vcentered is-glassy">
      <div class="column is-8">
        <TagFilterBar />
      </div>
      <div class="column has-text-right is-hidden-mobile">
        <b-button
          class="menubar-button"
          title="Add Bookmark"
          @click="addBookmarkModal(true)"
        >
          <b-icon
            icon="plus-circle"
            size="is-small"
          />
          <span
            class="is-hidden-mobile"
            style="margin-left: 8px"
          >Add Bookmark</span>
        </b-button>
      </div>
    </div>

    <b-modal
      v-model="isAddBookmarkActive"
      :width="720"
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <template>
        <BookmarkForm
          :url="addBookmarkUrl"
          :modal="true"
          @close="closeModal"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
  import TagFilterBar from '@/components/tags/TagFilterBar.vue'
  import BookmarkForm from '@/components/bookmarks/BookmarkForm.vue'

  export default {
    name: 'BookmarksFilterBar',
    components: {
      TagFilterBar,
      BookmarkForm
    },
    data: function() {
      return {
        isAddBookmarkActive: false,
        addBookmarkUrl: '',
      }
    },
    methods: {
      addBookmarkModal(showStatus) {
        let vm = this
        navigator.clipboard.readText().then(text => {
          const url = text.match(/(https?:[^\s]+)/)
          if (url != null) {
            vm.addBookmarkUrl = url[1]
          } else {
            vm.addBookmarkUrl = ''
          }
          vm.isAddBookmarkActive = showStatus
        }).catch(() => {
          vm.isAddBookmarkActive = showStatus
        })
      },
      closeModal() {
        this.addBookmarkModal(false)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .menubar-button {
    background: #ffffffab;
    border-color: transparent;
    color: #485fc7;
    text-decoration: none;

    &:hover {
      background: #f0f0f0ab;
      border-color: transparent;
      color: #485fc7;
      text-decoration: none;
    }
  }
</style>
